export const CAR_PREVIEW_PDF_ID = 0
